import React from 'react'
import { Carousel } from 'react-bootstrap';

export default class topCarousel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <Carousel className="top-carousel">
          <Carousel.Item className="shadow-effect">
            <div className="img-container">
              <img
                className="d-block w-100"
                src="https://i.ibb.co/yNhT9Wd/pexels-photo-373893.jpg"
                alt="First slide"
                className="img-fluid"
              />
            </div>
            {/*  <Carousel.Caption>
                  <h3> لوريم ايبسوم دولار</h3>
                  <p> ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور أنكايديديونتيوت لابوري</p>
                </Carousel.Caption> */}
          </Carousel.Item>
          {/*  <Carousel.Item>
              <div className="img-container">
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/f9s1j8x/lady-grey-suit-smiling-camera-background-stylish-cafe-with-lights.jpg"
                  https://i.ibb.co/fnyYgTb/papers-co-nv99-city-night-light-car-dark-nature-25-wallpaper.jpg
                  alt="First slide"
                  className="img-fluid"
                />
                </div>
              </Carousel.Item> */}
          <Carousel.Item>
            <div className="img-container">
              <img
                className="d-block w-100"
                src="https://i.ibb.co/nmbQ0Cm/Riyadh.jpg"
                alt="First slide"
                className="img-fluid"
              />
            </div>
          </Carousel.Item>
        </Carousel>
      </>
    )
  }
}
